import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Breadcrumbs from '../components/Breadcrumbs';

function ExerciseDetail() {
  const API_URL = process.env.REACT_APP_API_URL;
  const { interfaceLang, courseLang, courseSlug, exerciseId } = useParams();  // Récupère l'ID de l'exercice à partir de l'URL
  const [exercise, setExercise] = useState(null);
  const [userAnswer, setUserAnswer] = useState('');
  const [shuffledLeft, setShuffledLeft] = useState([]);  // Colonnes mélangées à gauche
  const [shuffledRight, setShuffledRight] = useState([]);
  const [feedback, setFeedback] = useState(null);
  const [alreadyCompleted, setAlreadyCompleted] = useState(false);
  const [leftSelected, setLeftSelected] = useState(null);  // Sélection à gauche
  const [rightSelected, setRightSelected] = useState(null); // Sélection à droite
  const [associations, setAssociations] = useState([]);
  const [exerciseCompleted, setExerciseCompleted] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    // Réinitialiser les états
    setExercise(null);
    setUserAnswer('');
    setFeedback(null);
    setAlreadyCompleted(false);
    setAssociations([]); // Réinitialiser les associations
    setLeftSelected(null);
    setRightSelected(null);
    setExerciseCompleted(false); // Réinitialiser l'état de l'exercice terminé

    // Récupérer les détails de l'exercice
    axios.get(`${API_URL}/cours/api/exercises/${exerciseId}/`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    .then(response => {
      setExercise(response.data);
      setAlreadyCompleted(response.data.already_completed);
      
      const shuffled = shuffleArray(response.data.options);
      setShuffledLeft([...shuffled]);
      setShuffledRight([...shuffleArray(shuffled)]); 
    })
    .catch(error => {
      console.error("Erreur lors de la récupération de l'exercice :", error);
    });
  }, [exerciseId]);

  // Fonction pour mélanger un tableau de manière aléatoire
  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const token = localStorage.getItem('access_token');

    // Soumettre la réponse de l'utilisateur
    axios.post(`${API_URL}/cours/api/exercises/${exerciseId}/submit/`, {
      answer: userAnswer
    }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    .then(response => {
      console.log("js retour post")
      setFeedback(response.data.message);  // Affiche le feedback correct/incorrect
      setAlreadyCompleted(response.data.already_completed); // Met à jour l'état si déjà complété
    })
    .catch(error => {
      console.error("Erreur lors de la soumission de la réponse :", error);
    });
  };



  // Fonction pour gérer la sélection d'un bouton à gauche (choix d'entrée)
  const handleLeftClick = (index) => {
    // Si déjà sélectionné, on désélectionne
    if (leftSelected === index) {
      setLeftSelected(null);
    } else {
      setLeftSelected(index);  // Sinon, on sélectionne
      setFeedback('');  // Réinitialiser le message d'erreur

      if (rightSelected !== null) {
        checkAssociation(index, rightSelected);  // Vérifier l'association
      }
    }
  };

  // Fonction pour gérer la sélection d'un bouton à droite (solutions)
  const handleRightClick = (index) => {
    // Si déjà sélectionné, on désélectionne
    if (rightSelected === index) {
      setRightSelected(null);
    } else {
      setRightSelected(index);  // Sinon, on sélectionne
      setFeedback('');  // Réinitialiser le message d'erreur
    }

    // Si un bouton à gauche et un bouton à droite sont sélectionnés, on vérifie l'association
    if (leftSelected !== null) {
      checkAssociation(leftSelected, index);  // Vérifier l'association
    }
  };

  // Fonction pour vérifier si l'association est correcte
  const checkAssociation = (leftIndex, rightIndex) => {
    const leftPair = shuffledLeft[leftIndex];  // Valeur à gauche mélangée
    const rightPair = shuffledRight[rightIndex];  // Valeur à droite mélangée
  
    // Comparer les paires par clé et valeur
    if (Object.keys(leftPair)[0] === Object.keys(rightPair)[0] && Object.values(leftPair)[0] === Object.values(rightPair)[0]) {
      // Utiliser une fonction de mise à jour pour s'assurer que les associations sont correctes
      setAssociations((prevAssociations) => {
        const newAssociations = [...prevAssociations, { [Object.keys(leftPair)[0]]: Object.values(leftPair)[0] }];
        
        console.log(newAssociations)
        // Vérifier si toutes les associations sont faites
        if (newAssociations.length === exercise.options.length) {
          
          
          handleExerciseCompletion(newAssociations);  // Valider l'exercice si terminé
        }
  
        return newAssociations;
      });
      
      setLeftSelected(null);
      setRightSelected(null);
      
    } else {
      setFeedback('Erreur ! Réessayez.');  // Message d'erreur en cas de mauvaise association
      resetSelections();  // Réinitialiser uniquement les sélections
    }
  };
  

  // Réinitialiser uniquement les sélections sans effacer les associations
  const resetSelections = () => {
    setLeftSelected(null);
    setRightSelected(null);
    setAssociations([]);
  };

  // Fonction pour marquer l'exercice comme terminé et envoyer les réponses correctes
  const handleExerciseCompletion = (finalAssociations) => {
    const token = localStorage.getItem('access_token');
    axios.post(`${API_URL}/cours/api/exercises/${exerciseId}/submit/`, {
      answer: finalAssociations  // Envoyer les associations correctes
    }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    .then(response => {
      setExerciseCompleted(true);  // Marquer l'exercice comme terminé
      setFeedback(response.data.message);
    })
    .catch(error => {
      console.error("Erreur lors de la soumission de l'exercice :", error);
    });
  };

  // Réinitialiser toutes les sélections
  const resetAll = () => {
    setLeftSelected(null);
    setRightSelected(null);
    //setFeedback('');  // Réinitialiser le message d'erreur
    setAssociations([]);  // Tout réinitialiser
  };

  const renderForm = () => {
    switch (exercise.question_type) {
      case "QCM":
      case "VraiFaux":
        return (
          <form onSubmit={handleSubmit} className="space-y-4">
            {exercise.options.map((option, index) => (
              <div key={index} className="flex items-center space-x-2">
                <input
                  type="radio"
                  id={`option${index}`}
                  name="answer"
                  value={option}
                  onChange={(e) => setUserAnswer(e.target.value)}
                  className="h-4 w-4 text-blue-600 border-gray-300 focus:ring-blue-500"
                />
                <label htmlFor={`option${index}`}>{option}</label>
              </div>
            ))}
            <button type="submit"
            className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition">
              Soumettre
            </button>
          </form>
        );

      case "Traduction":
      case "CompleterPhrase":
        return (
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="text"
              value={userAnswer}
              onChange={(e) => setUserAnswer(e.target.value)}
              placeholder="Votre réponse"
              className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            <button type="submit"
            className="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-700 transition">
              Soumettre
            </button>
          </form>
        );

      case "Correspondance":
        return (
          <div className="flex justify-between space-x-8" style={{ display: 'flex', justifyContent: 'space-between' }}>
            {/* Colonne gauche - Entrées */}
            <div className="space-y-4">
              {shuffledLeft.map((option, index) => (
                <button
                key={index}
                className={`block w-full px-4 py-2 rounded-md text-left ${
                  leftSelected === index ? 'bg-yellow-300' : associations.some(pair => Object.keys(pair)[0] === Object.keys(option)[0]) ? 'bg-green-200' : 'bg-white'
                } border border-gray-300 hover:bg-blue-100 transition`}
                onClick={() => handleLeftClick(index)}
              >
                {Object.keys(option)[0]} {/* Clé (entrée) */}
              </button>
              ))}
            </div>

            {/* Colonne droite - Solutions */}
            <div className="space-y-4">
              {shuffledRight.map((option, index) => (
                <button
                key={index}
                className={`block w-full px-4 py-2 rounded-md text-left ${
                  rightSelected === index ? 'bg-yellow-300' : associations.some(pair => Object.values(pair)[0] === Object.values(option)[0]) ? 'bg-green-200' : 'bg-white'
                } border border-gray-300 hover:bg-blue-100 transition`}
                onClick={() => handleRightClick(index)}
              >
                {Object.values(option)[0]} {/* Valeur (solution) */}
              </button>
              ))}
            </div>
          </div>

          
        );

      default:
        return <p className="text-red-500">Type d'exercice inconnu</p>;
    }
  };


  // Exemple de structure pour le fil d'Ariane
  const breadcrumbsLinks = [
    { label: 'Accueil', path: `/${interfaceLang}` },
    { label: 'Cours d\'espagnol', path:  `/${interfaceLang}/courses/${courseLang}` },
    { label: 'Cours', path: `/${interfaceLang}/course/${courseLang}/${courseSlug}` },
    { label: 'Exercice', path: `/${interfaceLang}/course/${courseLang}/${courseSlug}/${exerciseId}` }
  ];

  return (
    <div className="max-w-4xl mx-auto mt-8 p-6 bg-white rounded-lg shadow-lg">

      {/* Utilisation du fil d'Ariane */}
      <Breadcrumbs links={breadcrumbsLinks} />

      {exercise ? (
        <div>
          <h2 className="text-2xl font-bold text-blue-600 mb-4">{exercise.question}</h2>
          {alreadyCompleted && (
            <p className="text-green-600 mb-4">Vous avez déjà réussi cet exercice, mais vous pouvez le refaire.</p>
          )}

          {/* Afficher le formulaire correspondant au type d'exercice */}
          {renderForm()}
          
          {feedback && <p>{feedback}</p>}

          {feedback === "Réponse correcte" && (
            <button onClick={() => navigate(`/${interfaceLang}/course/${courseLang}/${courseSlug}/exercise/${parseInt(exerciseId) + 1}`)} 
            className="mt-4 bg-green-500 text-white px-4 py-2 rounded-md hover:bg-green-700 transition">
              Passer à l'exercice suivant
            </button>
          )}

          {feedback === "Réponse incorrecte" && (
            <button onClick={() => alert(`La réponse correcte est : ${exercise.correct_answer}`)}
            className="mt-4 bg-yellow-500 text-white px-4 py-2 rounded-md hover:bg-green-700 transition">
              Afficher la réponse correcte
            </button>
          )}
        </div>
      ) : (
        <p className="text-gray-700">Chargement de l'exercice...</p>
      )}
    </div>
  );
}

export default ExerciseDetail;
